/* --------------------------------------------------------------------------------------
   actionBar.component.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const actionBarComponent = {
  template: `
  <div id="{{vm.actionBarId}}" class="xrx-action-bar {{vm.getPrimaryBackground()}}">
    <button xw-button ng-show="vm.$attrs.cancel" class="xrx-action-bar-button-left" glyph="close" no-text ng-click="vm.cancel()"></button>
    <div class="xrx-action-bar-label {{vm.appSettings.primaryColor}}"><div class="action-bar-label-text">{{vm.title}}</div></div>
    <button id="{{vm.id}}-ok-button" off="vm.disableOk" ng-class="{'disabled' : vm.disableOkStyle }" xw-button class="xrx-action-bar-button-right" glyph="checkmark" ng-click="vm.ok()">{{ 'OK' | translate }}</button>
  </div>
  `,
  controllerAs: 'vm',
  controller: class actionBarCtrl {
    /* @ngInject*/
    constructor(appSettings, $attrs) {
      this.appSettings = appSettings
      this.$attrs = $attrs
    }
    getPrimaryBackground() {
      if (this.background == 'primary')
        return "xrx-background " + this.appSettings.primaryColor
    }
  },
  bindings: {
    title: '@',
    cancel: '&',
    ok: '&',
    disableOk: '<',
    disableOkStyle: '<',
    background: '@',
    actionBarId: '@'
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/actionBar.component.js